module.exports = __webpack_public_path__ + "static/media/aa.79c2d1cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imports/aa.gif
// module id = 784
// module chunks = 0